import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import moment from 'moment';

import PTORequest from "./Request";
import RequestList from "./RequestListModal";


export default class PTOModal extends Component {

    state = {
        isOpenRequestList: false,
    }

    openRequestListModal = () => {
        this.setState({isOpenRequestList: true});
    }

    closeRequestListModal = () => {
        this.setState({isOpenRequestList: false});
    }

    render = () => {
        const {isOpenRequestList} = this.state;
        const {modal, toggleModal, isStaff} = this.props;

        return (
            <Modal isOpen={modal} size="lg" toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Time Off Request
                </ModalHeader>
                <ModalBody className="bg-white">
                    <PTORequest {...this.props} />
                </ModalBody>
                <ModalFooter>
                    {isStaff ? 
                        <Button className='btn btn-primary' 
                            onClick={this.openRequestListModal}
                        >
                            Show Request List
                        </Button> : null
                    }
                    <Button className='btn btn-secondary' onClick={toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
                {isOpenRequestList && 
                    <RequestList {...this.props} 
                        modal={isOpenRequestList}
                        toggleModal={this.closeRequestListModal}
                        year={moment().year()}
                    /> 
                }
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pto/PTORequestModal.js